export const HOME_EVENT_NAMES = {
  VIEWED_SIGNED_IN_LANDING_PAGE: 'Viewed Signed In Landing Page',
  CLICKED_NYC_UPCOMING_WEBINARS: 'Clicked Upcoming Webinars',
  CLICKED_OPEN_GROW: 'Clicked Open Grow',
  CLICKED_LAUNCH_SCORING_TOOL: 'Clicked Launch Scoring Tool',
  CLICKED_POST_LINK: 'Clicked Post Link',
  CLICKED_VIEW_ALL_POSTS: 'Clicked View All Posts',
  CLICKED_UPCOMING_WEBINAR: 'Clicked Upcoming Webinar',
  CLICKED_VIEW_ALL_WEBINARS: 'Clicked View All Webinars',
  CLICKED_ON_DEMAND_TRAINING: 'Clicked On Demand Training Button'
}

export const FROM_HOME = { ref: 'home' }
